import { render, staticRenderFns } from "./Disk.vue?vue&type=template&id=fd567774&scoped=true"
import script from "./Disk.vue?vue&type=script&lang=js"
export * from "./Disk.vue?vue&type=script&lang=js"
import style0 from "./Disk.vue?vue&type=style&index=0&id=fd567774&prod&lang=less"
import style1 from "./Disk.vue?vue&type=style&index=1&id=fd567774&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd567774",
  null
  
)

export default component.exports